import {
  CopyrightOutlined,
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
  PhoneOutlined,
  QuestionCircleOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import useViewport from "components/UseViewport/UseViewport";
import colors from "constants/colors";
import { Link } from "react-router-dom";

import HallOfFame from "./HallOfFame/HallOfFame";

const { Title, Paragraph } = Typography;

const Footer = () => {
  const { width } = useViewport();
  const breakpoint = 900;

  return (
    <>
      <Row style={{ backgroundColor: colors.darkGray, marginTop: "5%" }} className="footer">
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
          style={{ width: "100%", paddingLeft: "5%", paddingRight: "2%", paddingTop: "5%" }}
        >
          <Col span={width < breakpoint ? 24 : 15}>
            {/* TODO fix styling */}
            <Title style={{ color: "white", fontSize: "1.5em" }}>Karrieredagene NTNU</Title>
            <Paragraph style={{ color: "white", paddingTop: "1%" }}>
              KarriereDagene har siden 2004 blitt arrangert av studenter ved linjen industriell økonomi og
              teknologiledelse på NTNU. Bindeleddet NTNU står bak planleggingen av arrangementet, som gjennomføres i
              samarbeid med 4. klasse. Det som begynte som en liten jobbmesse i Glassgården med 24 bedrifter har etter
              hvert vokst til å bli Norges største med over 150 bedrifter.
            </Paragraph>
          </Col>
          <Col span={width < breakpoint ? 24 : 9} style={width < breakpoint ? {} : { textAlign: "right" }}>
            <Paragraph>
              <a style={{ color: "lightgrey" }} href="https://www.facebook.com/KarriereDageneNTNU?locale=nb_NO">
                <FacebookFilled style={{ fontSize: "2.2em" }} />
              </a>
              <a style={{ color: "lightgrey" }} href="https://www.instagram.com/kdntnu/">
                <InstagramFilled style={{ fontSize: "2.2em", paddingLeft: "5%" }} />
              </a>
              <a style={{ color: "lightgrey" }} href="https://no.linkedin.com/company/karrieredagene-ntnu">
                <LinkedinFilled style={{ fontSize: "2.2em", paddingLeft: "5%" }} />
              </a>
            </Paragraph>
          </Col>
        </Row>

        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
          style={{ width: "70%", paddingLeft: "5%", paddingRight: "5%", paddingTop: "3%", paddingBottom: "3%" }}
        >
          <Col span={width < breakpoint ? 24 : 8}>
            <Paragraph>
              <Link to="/kd/contact-us/" style={{ textDecoration: "none", color: "white" }}>
                <QuestionCircleOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Ofte stilte spørsmål
              </Link>
            </Paragraph>
          </Col>
          <Col span={width < breakpoint ? 24 : 8}>
            <Paragraph>
              <Link to="/kd/contact-us/" style={{ textDecoration: "none", color: "white" }}>
                <PhoneOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Kontaktinformasjon
              </Link>
            </Paragraph>
          </Col>
          <Col span={width < breakpoint ? 24 : 8}>
            <Paragraph>
              <Link to="/kd/about-us/members/" style={{ textDecoration: "none", color: "white" }}>
                <TeamOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Våre medlemmer
              </Link>
            </Paragraph>
          </Col>
        </Row>

        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
          style={{ width: "100%", paddingLeft: "5%", paddingRight: "2%" }}
        >
          <Col span={width < breakpoint ? 24 : 12}>
            <Link to="/privacy-policy/" style={{ textDecoration: "none", color: "grey" }}>
              {"Personvern | "}
            </Link>
            <Link to="/user-terms/" style={{ textDecoration: "none", color: "grey" }}>
              {"Brukevilkår | "}
            </Link>
            <HallOfFame />
          </Col>
          <Col span={width < breakpoint ? 24 : 12} style={width < breakpoint ? {} : { textAlign: "right" }}>
            <Paragraph style={{ color: "grey", paddingRight: "0.37em" }}>
              {new Date().getFullYear()} <CopyrightOutlined /> Karrieredagene NTNU. All rights reserved.
            </Paragraph>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default Footer;
